import * as formValidation from 'Modules/formValidation';

namespace BHW.caseDetails {

	const POST_UPDATE_CASE = '/api/salesforce/update-case';
	const POST_UPLOAD_FILE = '/api/salesforce/upload-file';

	let $alertSuccess = $('.js-alert-success');
	let $alertDanger = $('.js-alert-danger');

	let $postComment = $('#post-comment');
	let $postCommentForm = $('#post-comment-form');
	let $postCommentComment = $('#post-comment-comment');
	let $postCommentSubmit = $('#post-comment-submit');
	let $postCommentPleaseWait = $('#post-comment-please-wait');
	let $postCommentCancel = $('#post-comment-cancel');

	let $uploadFile = $('#upload-file');
	let $uploadFileForm = $('#upload-file-form');
	let $uploadFileComment = $('#upload-file-comment');
	let $uploadFileFile = $('#upload-file-file');
	let $uploadFileSubmit = $('#upload-file-submit');
	let $uploadFilePleaseWait = $('#upload-file-please-wait');
	let $uploadFileCancel = $('#upload-file-cancel');
	let uploadFiles =[];

	let constraintsComment = {
		'post-comment-comment': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Comment Required'
			}
		},
	};

	let constraintsUploadFile = {
		'upload-file-comment': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Comment Required'
			}
		},
		'upload-file-file': {
			presence: {
				allowEmpty: false,
				message: '^' + 'File Required'
			}
		}
	};

	let toggleForm = function () {
		$('.js-toggle-form-visibility').each(function () {
			let $this = $(this);

			$this.on('click', function () {
				$($this.data('target')).toggleClass('hidden').find('textarea').focus();

			});
		})
	};

	let validateField = function (e, form) {
		$(e.target).addClass('dirty');
		let constraints = {};
		let values = {};
		let $submit = $;
		switch (form) {
			case 'comment':
				constraints = constraintsComment;
				values = {
					'post-comment-comment': $postCommentComment.val()
				};
				$submit = <any>$postCommentSubmit;
				break;
			case 'uploadFile':
				constraints = constraintsUploadFile;
				values = {
					'upload-file-comment': $uploadFileComment.val(),
					'upload-file-file': $('.js-file-input-value').text()
				};
				$submit = <any>$uploadFileSubmit;
		}		
	};

	let maxCharsCheck = function(e, hint) {
		let $input = $(e.target);
		let $hint = $(hint);
		let maxlength = parseInt($input.attr('maxlength'));
		let length = $input.val().toString().length;
		$hint.html((maxlength-length) + ' ' + $input.data('message'));
	};

	let inputEventListeners = function () {
		$postCommentComment.on('blur change', function (e) {
			validateField(e, 'comment');
		});

		$postCommentComment.on('keyup', function (e) {
			maxCharsCheck(e, '#post-comment-chars-remaining');
		});

		$uploadFileComment.on('blur change', function (e) {
			validateField(e, 'uploadFile');
		});

		$uploadFileComment.on('keyup', function (e) {
			maxCharsCheck(e, '#upload-file-comment-chars-remaining');
		});
	};

	let setupHandlers = function(){
		//waiting a second here so that the fileinput.ts binding that happens can be turned off.
		setTimeout(function(){
			$('input[type=file]').off('change.file');
			$('#upload-file-file').on('change.upload', function(e){
				var $value = $(this).siblings('.js-file-input-value');
				var $this = $(this);
				var $eTarget = <any>e.target;
				if (((this) as any).files && ((this) as any).files[0]) {
					if($eTarget.files.length <= 5)
					{
						uploadFiles = [];
						var output = [];
						for(var i=0; i<$eTarget.files.length; i++)
						{
							uploadFiles.push($eTarget.files[i]);
							let removeLink = '<i data-fileid=\"' + i + '\" class="icon icon-times file-input-close js-remove-file text-blue-bright" title="Remove Image"></i>';
							output.push('<li><strong>'+ $eTarget.files[i].name + '</strong>'+ removeLink+ '</li> ');
						}
						$value.html('');
						$value.append(output.join(""));
						if($this.data("accept")) {
							let fileAssocArray = $this.data("accept").split(',');
							for(var i=0; i<$eTarget.files.length; i++)
							{
								let fileName = $eTarget.files[i].name;
								let fileExt = (fileName.split(/[. ]+/).pop()).toLowerCase();
								if(fileAssocArray.indexOf(`.${fileExt}`) > -1)
								{

								}
								else
								{
									$value.html('');
									alert(`.${fileExt} files are not allowed. Please choose one of the following file types: (${fileAssocArray})`);
								}
							}
						}
					}
					else
					{
						alert(`Cannot upload more than 5 files`);
					}
				} else {
					$value.html('');
				}
			});
		}, 1000);

		// remove clicked file
		$('body').on('click.register', '.js-remove-file', function(e){
			e.preventDefault();
			var fileName = $(this).parent().children("strong").text();
			for(let i = 0; i < uploadFiles.length; ++ i){
				if(uploadFiles[i].name == fileName){
					uploadFiles.splice(i, 1);
				}
			}
			$(this).parent().remove();
		});
	};

	let submitPostComment = function () {
		$postCommentSubmit.on('click', function (e) {
			e.preventDefault();

			$('.js-alert').addClass('hidden');

			$postCommentSubmit.addClass('hidden');
			$postCommentPleaseWait.removeClass('hidden');
			$postCommentCancel.attr('disabled', '');

            let data = new FormData();
			data.append("Id", location.search.slice(1).split('=')[1]);
			data.append("Comment", $postCommentComment.val().toString());
			let comment = {
				id: location.search.slice(1).split('=')[1],
				Comment: $postCommentComment.val()
			};

			$.ajax({
				url: POST_UPDATE_CASE,
				type: 'POST',
				dataType: 'json',
				data: data,
				processData: false,
				contentType: false // not json
			})
				.done(function () {
					$('[data-target="#post-comment"]').click();
					$alertSuccess.removeClass('hidden');
					window.location.reload();
				})
				.fail(function (response) {
					$alertDanger
						.removeClass('hidden')
						.find('.alert__text');
						//.text(response.responseJSON.ExceptionMessage);
					$postCommentSubmit.removeClass('hidden');
					$postCommentPleaseWait.addClass('hidden');
				})
				.always(function () {
					window.scrollTo(0, 0);
					$postCommentCancel.removeAttr('disabled');
				});
		});
		$postCommentCancel.on('click', function (e) {
			e.preventDefault();

			formValidation.resetForm($postCommentForm);
			$('[data-target="#post-comment"]').click();
		})
	};

	let submitUploadFile = function () {
		$uploadFileSubmit.on('click', function (e) {
			e.preventDefault();

			$('.alert').addClass('hidden');

			$uploadFileSubmit.addClass('hidden');
			$uploadFilePleaseWait.removeClass('hidden');
			$uploadFileCancel.attr('disabled', '');

			let data = new FormData();
			data.append("Id", location.search.slice(1).split('=')[1]);
			data.append("Comment", $uploadFileComment.val().toString());
            for(var i=0; i<($uploadFileFile[0] as any).files.length; i++)
		    data.append("Files" +i, ($uploadFileFile[0] as any).files[i]);
			$.ajax({
				url: POST_UPLOAD_FILE,
				type: 'POST',
				dataType: 'json',
				data: data,
				processData: false,
				contentType: false // not json
			})
				.done(function () {
					$('[data-target="#upload-file"]').click();
					$alertSuccess.removeClass('hidden');
					window.location.reload();
				})
				.fail(function (response) {
					$alertDanger
						.removeClass('hidden')
						.find('.alert__text');
						//.text(response.responseJSON.ExceptionMessage);
					$uploadFileSubmit.removeClass('hidden');
					$uploadFilePleaseWait.addClass('hidden');
				})
				.always(function () {
					window.scrollTo(0, 0);
					$uploadFileCancel.removeAttr('disabled');
				});
		});
		$uploadFileCancel.on('click', function (e) {
			e.preventDefault();

			formValidation.resetForm($uploadFileForm);
			$('.js-file-input-value').text('');
			$('[data-target="#upload-file"]').click();
		});
	};

	export const init = () => {
		// Something is unwrapping the form so this puts it back
		if($postCommentForm.length === 0){
			$postCommentForm = $(`<form id="post-comment-form" name="post-comment-form">`);
			$postComment.append($postCommentForm.append($postComment.children().detach()));
		}
		if($uploadFileForm.length === 0){
			$uploadFileForm = $(`<form id="upload-file-form" name="upload-file-form">`);
			$uploadFile.append($uploadFileForm.append($uploadFile.children().detach()));
		}

		toggleForm();
		inputEventListeners();
		setupHandlers();
		submitPostComment();
		submitUploadFile();
	};
}

document.addEventListener("DOMContentLoaded", () => {
	BHW.caseDetails.init();
});

